import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[alphaNumericValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: AplhaNumericDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class AplhaNumericDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^[a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç0-9- ]*$/.test(control.value)
     ? null
     : { invalid : true };
 }
}
